import { Modal } from "react-bootstrap"
import ReactLoading from "react-loading"

export default function GenerateBirModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.hide} size="lg" centered>
        <Modal.Header className="return-header">
          <span
            className={
              props.type === "disapprove" ? "color-red" : "text-warning"
            }
          >
            {" "}
            PLEASE CONFIRM{" "}
          </span>
        </Modal.Header>
        <Modal.Body className="return-body text-center">
          <span>{props.message}</span>
          <div className="d-flex justify-content-end my-3 pb-1 mt-5">
            <button
              type="button"
              className={
                props.type === "disapprove"
                  ? "button-warning me-3"
                  : "button-secondary me-3"
              }
              onClick={props.hide}
            >
              Cancel
            </button>
            {props.isClicked === true && (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            )}
            {props.isClicked === false && (
              <button
                type="button"
                className={
                  props.type === "disapprove"
                    ? "button-warning-fill"
                    : "button-primary"
                }
                onClick={props.handler}
              >
                Proceed
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
